export default {"src":"/_next/static/image/public/assets/logos/logo-name.b9c797df7047a3b083b38691e4d221a4.svg","height":51,"width":238};